module.exports = __webpack_public_path__ + "static/sec-2dba7b7385a50b039f1216ba25e6ecc3.png";